module.exports = __webpack_public_path__ + "img/slide-home-image-1.56e61fbb.png";